import { createElement } from "./dom_utils.js";

function getFileIcon(fileName) {
  const extension = fileName.split(".").pop().toLowerCase();
  const iconMap = {
    pdf: "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/pdf_file.svg",
    doc: "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/doc_file.svg",
    docx: "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/doc_file.svg",
    ppt: "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/ppt_file.svg",
    pptx: "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/ppt_file.svg",
    csv: "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/csv_file.svg",
    xls: "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/csv_file.svg",
    xlsx: "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/csv_file.svg",
  };
  return (
    iconMap[extension] ||
    "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/default_file.svg"
  );
}

function createFileAttachmentDisplay(attachment) {
  const container = createElement("div", {
    className: "widget_attachment_icon",
  });

  const iconUrl = getFileIcon(attachment.file_name);
  const icon = createElement("img", {
    src: iconUrl,
    alt: "file icon",
    style: "width: 20px; height: 20px; object-fit: contain;",
  });

  container.appendChild(icon);

  return container;
}

export default createFileAttachmentDisplay;

